import { render, staticRenderFns } from "./room-share.vue?vue&type=template&id=2bdab2a8"
import script from "./room-share.vue?vue&type=script&lang=js"
export * from "./room-share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports